import { Access } from './Access'
import { Seat } from './Seat'

export interface Licence {
  activationDate: number
  creationDate: number
  expirationDate: number
  id: string
  availableAccessNumber: number
  availableSeatNumber: number
  licenceStatus: string
  productName: string
  type: LicenceType
  ownerId: string
  ownerName: string
  ownerEmail: string
  membershipType: MembershipType
  accesses: Access[]
  seats: Seat[]
  licenceFee: number
  membershipFee: number
  subscriptionFee: number
  currency: string
  billingType: LicenceBillingType
  protectionType: LicenceProtectionType
  clientSpecificExtension: ClientSpecificExtensionType
}

export type MembershipType = '' | 'basic' | 'pro' | 'premium'
export type LicenceType =
  | 'consteel_full'
  | 'consteel_hall'
  | 'consteel_full_with_falcon'
  | 'consteel_hall_with_falcon'
  | 'consteel_starter'
  | 'consteel_starter_with_falcon'
  | 'distributor'
  | 'distributor_with_falcon'
  | 'graduate'
  | 'university'
  | 'teacher'
  | 'trial'
export type LicenceBillingType = '' | 'monthly_fee' | 'yearly_fee' | 'entry_fee'
export type LicenceProtectionType = '' | 'online' | 'usb_dongle'
export type ClientSpecificExtensionType =
  | ''
  | 'kesz'
  | 'ruukki'
  | 'kspan'
  | 'metalcom'
  | 'astron'
  | 'techdaal'
  | 'developer'

export const NonCommercialLicences = [
  'distributor',
  'distributor_with_falcon',
  'graduate',
  'university',
  'teacher',
  'trial',
] as LicenceType[]

export const isLicenceNonCommercial = (licenceType: LicenceType): boolean => {
  return NonCommercialLicences.includes(licenceType)
}
